export default __webpack_public_path__ + "static/media/wildlife05.6d3d2f1a.png";